'use strict'

import React,{Component} from 'react';
import uuid from 'uuid';
import request from 'superagent';

import Layout from './Layout.jsx';
import AreaForm from './components/AreaForm.jsx';
import ProjectMenu from './components/ProjectMenu.jsx';
import PriorityTable from './components/PriorityTable.jsx';
import priority from '../app/utils/priority.js';
import riskResponseLabel from './risk/riskResponseLabel.js';

import RiskForm,{riskresponseLabel} from './risk/RiskForm.jsx';
import PresentationView from './risk/PresentationView.jsx';
import FormattedContent from './components/FormattedContent.jsx';

import sendCommand from '../app/utils/sendCommand.js';

import Translations from '../app/utils/translations.js';
let translations=new Translations([
    require('./risk/labels/english.js'),
    require('./risk/labels/norwegian.js')
]);

function assignPriority(item) {
  return item.status!=="Closed"
    ? Object.assign({},item,{row:parseInt(item.probability),column:parseInt(item.impact)})
    :  Object.assign({},item,{row:undefined,column:undefined});
}

class RiskItem extends Component {
  render() {
    return this.props.items.length>1 ? (
      <div style={{paddingTop:2}}>
        <span>...</span>
      </div>
    ) : this.props.items.length===1 ? (
      <div style={{paddingTop:5}}>{this.props.items[0].no}</div>
    ) : null;
  }
}

export class RiskTable extends Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let tableLabels={
      row: labels.general.probability,
      column: labels.general.impact
    };
    var items=this.props.items.slice(0).filter(item=>item.status!=="Closed").slice(0).map(assignPriority);
    return <PriorityTable {...this.props} labels={tableLabels} items={items}/>;
  }
}

class RiskListEntry extends Component {
  constructor(props) {
  	super(props);
  	this.state = {hover: false};
  }

  toggleHover(event) {
    event.preventDefault();
	   this.setState({hover: !this.state.hover});
   }

  selectItem() {
    if (this.props.onSelect!==undefined && this.props.item.readOnly!==true) {
      this.props.onSelect(this.props.item);
    }
  }
  render() {
    var item=this.props.item;
    var bgColor=this.state.hover ? "#f1fbfe" : this.props.backgroundColor;

    return (
      <div onClick={this.selectItem.bind(this)} onMouseEnter={this.toggleHover.bind(this)} onMouseLeave={this.toggleHover.bind(this)} style={{cursor:item.readOnly!==true ? "pointer" : undefined, display:"table-row", textAlign:"left", backgroundColor:bgColor, borderBottom:"solid 1px #939393", color:item.status==="Closed" ?  "lightgrey" : item.readOnly===true ? "#505050" : "#212121", textDecoration:item.status==="Closed" ? "line-through" : "none"}}>
        <div style={{paddingTop:2, paddingLeft:7, paddingRight:5}}>
                    <div style={{display:"table-cell,inline-block",marginTop:4, padding:8, borderRadius:"50%", width:0, hight:15, backgroundColor:priority.priorityColor(item,this.props.profile) }}> </div>
        </div>
        <div style={{display:"table-cell", padding:5}}>
          {item.no}
        </div>
        <div style={{display:"table-cell", padding:5}}>
          {item.title}
        </div>
        <div style={{display:"table-cell", padding:5}}>
          {item.category}
        </div>
        <div style={{display:"table-cell", padding:5}}>
          {item.cause}
        </div>
      </div>
    );
  }
}

class RiskList extends Component {
  render() {
    let labels=translations.getTranslation(this.props);
    var selectItem=this.props.onSelect;
    var type="followUp";
    return (
      <div>
        <div style={{display:"table", width:"100%", borderCollapse:"collapse"}}>
          <div style={{display: "table-row", pageBreakInside:"avoid", borderBottom:"solid 1px #939393", backgroundColor:"#ffffff",color:"#212121", fontWeight: "bold",textAlign:"left"}}>
            <div style={{display:"table-cell", paddingTop:5, paddingBottom:5, paddingLeft:10, pageBreakInside:"avoid"}}></div>
            <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.views.identify.columns.id}</div>
            <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.views.identify.columns.title}</div>
            <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.views.identify.columns.category}</div>
            <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.views.identify.columns.cause}</div>
          </div>
          {this.props.items.map((item,index)=>(
            <RiskListEntry key={item.id} {...this.props} item={item} onSelect={selectItem} backgroundColor={index%2===1 ? "#f7f7f7" : "white"}/>
          ))}
        </div>
      </div>
    );
  }
}

export class Risk extends Component {
  constructor(props) {
    super(props);
    var items=this.props.risks!==undefined ? this.props.risks : [];
    switch (this.props.examples) {
      case "true":
        items=[
          {id:"1234",no:"1",title:"Lack of commitment", probability:1, impact:3, type:"Threat", category:"Budget", proximity:"Imminent", cause:"Missing information", event:"No commitment", effect:"Delay of delivery",response:"Reduce"},
          {id:"12345",no:"2",title:"Low availablity of supplier", probability:4, impact:3},
          {id:"1245",no:"3",title:"Errors in specification", probability:3, impact:4},
          {id:"12645",no:"4",title:"High number of issues", probability:4, impact:4},
          {id:"123456",no:"5",title:"Lack of knowledge", probability:4, impact:4},
          {id:"21234",no:"6",title:"Lack of commitment 2", probability:1, impact:1, type:"Threat", category:"Budget", proximity:"Imminent", cause:"Missing information", event:"No commitment", effect:"Delay of delivery",response:"Reduce"},
          {id:"212345",no:"7",title:"Low availablity of supplier 2", probability:4, impact:2},
          {id:"21245",no:"8",title:"Errors in specification 2", probability:3, impact:3},
          {id:"212645",no:"9",title:"High number of issues 2", probability:2, impact:4},
          {id:"2123456",no:"10",title:"Lack of knowledge 2", probability:1, impact:5}
        ];
        break;
      case "priority":
        items=priority.allItems((item,index)=>Object.assign({},item,{id:uuid.v4(),no:index+1,title:"Risk "+(index+1)+" - "+item.classification+" (impact x probability: "+item.row*item.column+")",type:"threat", impact:item.column, probability:item.row}),this.props.profile);
        break;
    }
    this.state={
      manageRisk:false,
      mode: this.props.mode!==undefined ? this.props.mode : "identify",
      items:items,
      selected:props.selected
    };
  }

  componentWillReceiveProps(props) {
    if (props.items!==undefined) {
      this.setState({items:props.items});
    }
  }

  addNewRisk(event) {
    event.preventDefault();
    this.manageRisk({type:"Threat"});
  }

  manageRisk(item) {
    if (this.props.onDetails!==undefined) {
      this.props.onDetails({show:true});
    }
    this.setState({selected:item, manageRisk:true});
  }


  appendItem(command) {
    console.log("Calculated no "+(this.state.items.length+1));
    var newItem=Object.assign(
                  {},
                  command.item,
                  {
                    id:uuid.v4(),
//                    no:this.state.items.length+1,
                    probability:(command.item.probability!==undefined) ? parseInt(command.item.probability) : undefined,
                    impact:(command.item.impact!==undefined) ? parseInt(command.item.impact) : undefined
                  }
                );
/*
    this.setState({
      items:this.state.items.concat(newItem)
    });
*/
    var updateRisk=function(items) {
      this.setState({
        items:items,
        selected: Object.assign({},items.filter(item=>item.id===newItem.id)[0],{
          _currentProgress:command.item._progress
        })
      });
      if (this.props.onUpdate!==undefined) {
        this.props.onUpdate(items);
      }
    }.bind(this);

    var command={type:"addRisk",item:newItem};
    if (this.props.project.isProduct) {
      command=Object.assign({},command,{
        product: {id: this.props.project.id}
      });
    } else if (this.props.project.isRelease) {
      command=Object.assign({},command,{
        release: {id: this.props.project.id}
      });
    } else if (this.props.project.isProgramme) {
      command=Object.assign({},command,{
        programme: {id: this.props.project.id}
      });
    } else {
      command=Object.assign({},command,{
        project:{id:this.props.project.id}
      });
    }

    sendCommand(command)
      .then(response=>{
        updateRisk(response.items);
      })
      .catch(error=>{
        console.log("Got error",error);
        alert("Not able to add risk, please try again");
      });
  }

  updateExisting(command) {
    var existingItem=this.state.items.filter(item=>item.id===command.item.id)[0];
    var updatedItem=existingItem!==undefined ? Object.assign(
        {},
        command.item,
        {
          no:existingItem.no,
          probability:(command.item.probability!==undefined) ? parseInt(command.item.probability) : undefined,
          impact:(command.item.impact!==undefined) ? parseInt(command.item.impact) : undefined
        }
    )
    : undefined;
    var updateRisk=function(items) {
      this.setState({
        items:items,
        selected: Object.assign({},items.filter(item=>item.id===command.item.id)[0],{
          _currentProgress:command.item._progress
        })
      });
      if (this.props.onUpdate!==undefined) {
        this.props.onUpdate(items);
      }
    }.bind(this);

    var command={type:"updateRisk",item:updatedItem};
    if (this.props.project.isProduct) {
      command=Object.assign({},command,{
        product: {id: this.props.project.id}
      });
    } else if (this.props.project.isRelease) {
      command=Object.assign({},command,{
        release: {id: this.props.project.id}
      });
    } else if (this.props.project.isProgramme) {
      command=Object.assign({},command,{
        programme: {id: this.props.project.id}
      });
    } else {
      command=Object.assign({},command,{
        project:{id:this.props.project.id}
      });
    }

    sendCommand(command)
      .then(response=>{
        updateRisk(response.items)
      })
      .catch(error=>{
        console.log("Got error",error);
        alert("Not able to update risk, please try again");
      })
  }

  hideManageForm(command) {
    if (command.type!=="cancel") {
      if (command.item.id===undefined || command.item.id.trim().length===0) {
        this.appendItem(command);
      } else {
        this.updateExisting(command)
      }
    } else {
      if (this.props.onDetails!==undefined) {
        this.props.onDetails({show:false});
      }
      this.setState({manageRisk:false});
    }
  }

  showIdentifyView(event) {
    event.preventDefault();
    if (this.props.onListView!==undefined) {
      this.props.onListView();
    }
    this.setState({mode: "identify"});
  }

  showFollowUpView(event) {
    event.preventDefault();
    if (this.props.onListView!==undefined) {
      this.props.onListView();
    }
    this.setState({mode: "followUp"});
  }

  showPresentView(event) {
    event.preventDefault();
    if (this.props.onPresentation!==undefined) {
      this.props.onPresentation();
    }
    this.setState({mode: "present"});
  }

  render() {
    let labels=translations.getTranslation(this.props);
    var items=this.state.items
      .slice(0)
      .map(assignPriority)
      .sort(priority.getProfileSort(this.props.profile));
    if (this.props.size!==undefined) {
      items=items.slice(0,this.props.size);
    }
    return (


      <div style={{marginLeft:20, paddingTop:20, fontFamily:"Lato"}}>

        {this.state.manageRisk ? (
          <RiskForm
            {...this.props}
            item={this.state.selected}
            onCommand={this.hideManageForm.bind(this)}
          />
        ) : this.state.mode==="present" || this.props.view==="present" || this.props.view==="presentOnly" ? (
          <PresentationView {...this.props}
            items={items}
            selected={this.state.selected}
            onShowListView={this.showIdentifyView.bind(this)}
            onEdit={this.manageRisk.bind(this)}
          />
        ) : (


          <div style={{display:"flex", justifyContent:"center", fontFamily:"Lato", maxWidth:1016}}>
          <div >
              <div style={{backgroundColor:"#f7f7f7", padding:20, marginBottom:20, display:"flex", justifyContent: "space-between", flexWrap:"wrap" }}>

                <div>
                    <div style={{fontWeight:"bold", fontSize:14 }}>
                      {labels.general.title} <br></br>
                    </div>
                    <div style={{fontSize:30, fontWeight:"bold", float:"left"}}>
                      {labels.riskRegister.title}
                    </div>
                    <div style={{minWidth:200, maxWidth:450, paddingTop:50}}>
                        {labels.riskRegister.description} <br></br><br></br>
                        {labels.riskRegister.description2}
                    </div>
                </div>

                <div style={{width:200}}>
                </div>

                <div style={{float:"right", paddingBottom:20, paddingRight:20, paddingTop:20, backgroundColor:"#f7f7f7"}}>
                  <RiskTable
                    {...this.props}
                    items={items}
                    onSelect={this.manageRisk.bind(this)}
                  />
                </div>
              </div>


            <div style={{float:"left", marginTop:30, paddingLeft: 0, width:"100%", maxWidth:1016}}>

              <div style={{paddingBottom:15}}>
                <div style={{display: "flex", justifyContent:"flex-end"}}>

                  {this.state.mode!=="identify" ? (
                    <div onClick={this.showIdentifyView.bind(this)} style={{cursor:"pointer",  marginRight: 50}}>[<span style={{textDecoration:"underline"}}>{labels.views.identify.title}</span>]</div>
                  ) : (
                    <div style={{float:"left", marginRight: 50}}><b>{labels.views.identify.title}</b></div>
                  )}

                  {this.state.mode!=="followUp" ? (
                    <div onClick={this.showFollowUpView.bind(this)} style={{cursor:"pointer", marginRight: 50}}>[<span style={{textDecoration:"underline"}}>{labels.views.followUp.title}</span>]</div>
                  ) : (
                    <div style={{float:"left", marginRight: 50}}><b>{labels.views.followUp.title}</b></div>
                  )}

                  {this.state.mode!=="present" ? (
                    <div onClick={this.showPresentView.bind(this)} style={{cursor:"pointer",  marginRight: 50}}>[<span style={{textDecoration:"underline"}}>{labels.views.present.title}</span>]</div>
                  ) : (
                    <div style={{float:"left", marginRight: 50}}><b>{labels.views.present.title}</b></div>
                  )}



                  <div onClick={this.addNewRisk.bind(this)} style={{float:"right", cursor: "pointer", fontWeight:"bold", textDecoration:"underline"}}>
                    + {labels.general.add}
                  </div>

                </div>
              </div>
              <div>
                {this.state.mode==="followUp" ? (
                  <RiskReportList {...this.props} items={items.filter(item=>item.status!=="Closed")} onSelect={this.manageRisk.bind(this)}/>
                ) : (
                  <RiskList {...this.props} items={items} onSelect={this.manageRisk.bind(this)}/>
                )}
              </div>
            </div>
          </div>
          </div>
        )}
      </div>

    );
  }
}

class RiskReportEntry extends Component {
  constructor(props) {
  	super(props);
  	this.state = {hover: false};
  }

  toggleHover(event) {
    event.preventDefault();
	   this.setState({hover: !this.state.hover});
   }

  selectItem() {
    if (this.props.onSelect!==undefined && this.props.item.readOnly!==true) {
      this.props.onSelect(this.props.item);
    }
  }

  render() {
    let labels=translations.getTranslation(this.props);
    var item=this.props.item;
    var bgColor=this.state.hover ? "#f1fbfe" : this.props.backgroundColor;
    var comments=item.comments!==undefined ? "<i>"+labels.general.status+":</i>"+item.comments : ""; 
    return (
      <div onClick={this.selectItem.bind(this)} onMouseEnter={this.toggleHover.bind(this)} onMouseLeave={this.toggleHover.bind(this)} style={{cursor:(this.props.onSelect!==undefined) && item.readOnly!==true ? "pointer" : undefined, display:"table-row", backgroundColor:bgColor, borderBottom:"solid 1px #939393", color: item.readOnly===true ? "#505050" : undefined}}>
        <div style={{paddingTop:2, paddingLeft:7, paddingRight:5}}>
          <div style={{display:"table-cell,inline-block", marginTop:4, padding:8, borderRadius:"50%", width:0, hight:15, backgroundColor:priority.priorityColor(item,this.props.profile) }}> </div>
        </div>
        <div style={{display:"table-cell", padding:5}}>
          {item.no}
        </div>

        <div style={{display:"table-cell", padding:5}}>{item.title}</div>
        <div style={{display:"table-cell", padding:5, display:"flex", alignItems:"center"}}>
          <i>{riskResponseLabel(item.response,this.props.language)}</i>
          <div style={{paddingLeft:10}}><FormattedContent value={item.action+comments}/></div>
        </div>
        <div style={{display:"table-cell", padding:5}}>{item.ownerAndActionee}</div>
      </div>
    );
  }
}

class RiskReportList extends Component {
  render() {
    let labels=translations.getTranslation(this.props).views.followUp.columns;
    return (
      <div style={{display:"table", borderCollapse:"collapse", width:"100%"}}>
        <div style={{display: "table-row", borderBottom:"solid 1px #939393", pageBreakInside:"avoid", backgroundColor:"#ffffff", color:"#212121", fontWeight: "bold", textAlign:"left"}}>
          <div style={{display:"table-cell", paddingTop:5, paddingBottom:5, paddingLeft:10, pageBreakInside:"avoid"}}></div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.id}</div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.title}</div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.solution}</div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.ownerAndActionee}</div>
        </div>
        {this.props.items
          .map(risk=>Object.assign({},risk,{
            ownerAndActionee:
              (risk.owner!== undefined && risk.owner!==null ? risk.owner : "")+" / "+
              (risk.actionee!==undefined && risk.actionee!==null ? risk. actionee : "")
            }
          ))
          .map((item,index)=><RiskReportEntry key={item.id} {...this.props} onSelect={this.props.onSelect} backgroundColor={index%2===1 ? "#f7f7f7" : "white"} item={item}/>)}
      </div>
    );
  }
}

export class RiskReport extends Component {
  render() {
    var items=this.props.items.slice(0).map(assignPriority).sort(priority.getProfileSort(this.props.profile)).slice(0,5);
    return (
      <div>
        <RiskTable {...this.props} items={items}/>
        <div style={{paddingTop:20}}>
          <RiskReportList {...this.props} items={items}/>
        </div>
      </div>
    );
  }
}

export default class RiskPage extends Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <Risk {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/Risk.jsx